import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CommonButtonId from '../atoms/CommonButtonId';
// import DeleteMenuEventTextButton from '../atoms/DeleteMenuEventTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  },
  textDelete: {
    color: '#ccc',
    textAlign: 'center',
    paddingLeft: 12
  },
  menuImage: {
    width: 100,
    height: 63,
    objectFit: 'cover'
  },
  noImage: {
    width: 100,
    height: 63,
    backgroundColor: '#D1D1D1',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: '#A5A5A5',
    fontSize: 10
  },
  bookingMess: {
    whiteSpace: 'break-spaces'
  },
  disabledMenu: {
    opacity: 0.5
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  listBooking: PropTypes.arrayOf(
    PropTypes.shape({
      bookingId: PropTypes.number,
      status: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      bookingUsername: PropTypes.string,
      phoneNumber: PropTypes.string,
      gochiBillNo: PropTypes.number,
      shopId: PropTypes.string,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      includedTaxPrice: PropTypes.string,
      bookingMessage: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    listBooking,
    emptyRows,
    classes,
    page,
    rowsPerPage,
    onChangeBookingStatus,
    order,
    orderBy
  }) => {
    const bookings = _.orderBy(listBooking, orderBy, order);
    const onClickChangeStatus = id => {
      const ids = [];
      ids.push(id);
      onChangeBookingStatus(ids);
    };
    return (
      <TableBody>
        {bookings
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(booking => {
            const key = `${booking.bookingId}`;
            return (
              <TableRow key={key} hover>
                <TableCell>{booking.bookingId}</TableCell>
                <TableCell>
                  {(() => {
                    if (booking.status === 'WAITING') return '進行中';
                    return '完了';
                  })()}
                </TableCell>
                <TableCell>
                  <CommonButtonId
                    id={booking.bookingId}
                    className={classes.button}
                    title="お客様に連絡する"
                    disabled={booking.status === 'FINISHED'}
                    onClickAction={() => onClickChangeStatus(booking.bookingId)}
                  />
                </TableCell>
                <TableCell>{booking.createdAt}</TableCell>
                <TableCell>{booking.bookingTime}</TableCell>
                <TableCell>{booking.bookingUsername}</TableCell>
                <TableCell>{booking.phoneNumber}</TableCell>
                <TableCell>{booking.gochiBillNo}</TableCell>
                <TableCell>{booking.shopId}</TableCell>
                <TableCell>{booking.shopName}</TableCell>
                <TableCell>{booking.menuName}</TableCell>
                <TableCell>{booking.includedTaxPrice}</TableCell>
                <TableCell className={classes.bookingMess}>
                  {booking.bookingMessage}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          // <TableRow style={{ height: 49 * emptyRows }}>
          //   <TableCell colSpan={7} />
          // </TableRow>
          <></>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
